import { render, staticRenderFns } from "./blogsList.vue?vue&type=template&id=6be7854a&"
import script from "./blogsList.vue?vue&type=script&lang=js&"
export * from "./blogsList.vue?vue&type=script&lang=js&"
import style0 from "./blogsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports